"use client";
import { useState } from "react";
import { signIn } from "next-auth/react";
import { TextInput, Button, Loader } from "@mantine/core";

const EmailLogin = ({ callbackUrl }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");

    const validateEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    const handleLogin = async () => {
        if (!validateEmail(email)) {
            setError("Invalid email format");
            return;
        }

        setError("");
        setIsLoading(true);

        try {
            const result = await signIn("email", { email: email.toLowerCase(), callbackUrl: callbackUrl || '/' });

            if (result?.error) {
                console.error("Login error:", result.error);
                setIsLoading(false);
            } else {
                setTimeout(() => setIsLoading(false), 3000);
            }
        } catch (error) {
            console.error("Sign-in failed:", error);
            setIsLoading(false);
        }
    };

    return (
        <>
            <TextInput
                mb={6}
                label="Email address"
                placeholder="hello@gmail.com"
                size="md"
                error={error}
                onChange={(e) => setEmail(e.target.value)}
            />
            <Button
                disabled={isLoading}
                loading={isLoading}
                loaderProps={{ type: 'dots' }}
                fullWidth
                bg="secondary"
                onClick={handleLogin}
            >
                {isLoading ? "Logging in..." : "Login"}
            </Button>
        </>
    );
};

export default EmailLogin;
